import envVars from './envVars';

const BRANCH_IO_URL = 'https://macrostaxmealplanner.test-app.link';
const BRANCH_IO_URL_PROD = 'https://macrostaxmealplanner.app.link';
export const shareTeamLink = (tokenId) => `${envVars.BASE_URL === 'https://app-test.macrostax.com/api/team/v1' ? BRANCH_IO_URL : BRANCH_IO_URL_PROD}/team-invitation-link?team_token_id=${tokenId}`;
